import React,{useEffect} from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Stack,
  CheckPicker
} from 'rsuite';
const data2 = [
  'Eugenia',
  'Bryan',
  'Linda',
  'Nancy',
  'Lloyd',
  'Alice',
  'Julia',
  'Albert',
  'Louisa',
  'Lester',
  'Lola',
  'Lydia',
  'Hal',
  'Hannah',
  'Harriet',
  'Hattie',
  'Hazel',
  'Hilda'
].map(item => ({ label: item, value: item }));

const DrawerView = (props: DrawerProps) => {
  const { onClose, ...rest } = props;


  return (
    <Drawer backdrop="static" size="xs" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Title>Filters</Drawer.Title>
        <Drawer.Actions>
          <Button color="cyan" onClick={onClose} appearance="ghost">
            Cancel
          </Button>
          <Button color="cyan" onClick={onClose} appearance="primary">
            Confirm
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
          <Stack direction='column' alignItems='center'>

          <CheckPicker placement="autoVerticalStart" data={data2} size="xs" appearance="default" placeholder="Height (10)" style={{ width: 350,  marginBottom: 20, marginTop:20  }} />
          <CheckPicker placement="autoVerticalStart" data={data2} size="xs" appearance="default" placeholder="Width (12)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker placement="autoVerticalStart" data={data2} size="xs" appearance="default" placeholder="Length (6)" style={{ width: 350,  marginBottom: 20 }} />
          
          </Stack>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerView;